import { styled } from '@mui/material';
import React from 'react';
import { BrandclubProductCard } from '../components/BrandclubProductCard/index.js';
import BrandclubLoading from '../components/BrandclubLoading/index.js';
import { ProductGrid } from './SearchResultsStyles.js';

const Container = styled('div')({});
const SearchProductGrid = ({ loading, products, LinkComponent, containerWidthOverride, onShareClick, children, }) => {
    return (React.createElement(Container, null, loading ? (React.createElement(BrandclubLoading, { type: "productGrid" })) : (React.createElement(ProductGrid, { className: "grid", containerWidthOverride: containerWidthOverride },
        children,
        products.map((product, idx) => {
            return (React.createElement(BrandclubProductCard, { className: "fullsize_responsive", LinkComponent: LinkComponent, onShareClick: (e) => onShareClick(e, product), key: idx, product: product }));
        })))));
};

export { SearchProductGrid as default };
//# sourceMappingURL=SearchProductGrid.js.map
